import React, { Component } from 'react';
import './Input.css';

class Input extends Component {
  state = { value: '' };

  handleChange = (event) => {
    this.setState({ value: event.target.value });
  }
  render() {

    const {
      id: idInput = '0',
      type: typeInput = "text",
      hidden: hiddenInput = false,
      required: requiredInput = false,
      ariaDescribedby: descriptionInput = "descriptionInput"
    } = this.props;

    return (
      <div className={`input ${this.props.modifier ? this.props.modifier : ''}`}>
        <input
          className="input__text"
          type={typeInput}
          id={idInput}
          value={this.props.value ? this.props.value : this.state.value}
          onChange={this.handleChange}
          name={this.props.name}
          hidden={hiddenInput}
          required={requiredInput}
          aria-describedby={descriptionInput}
          pattern={this.props.pattern}
        />
        <label className="input__label" htmlFor={idInput}>{this.props.label}</label>
        <span id={descriptionInput} className="input__errorMessage" />
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Input.js